import { FormikProvider, useFormik } from 'formik';
import { useEffect } from 'react';
import { Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';

import FilledInBy from './common/FilledInBy';
import Title from './common/Title';

export default function SignatureModal(props: {
	fillInBy: graphql.EvaluationFillInBy;
	item: graphql.EvaluationSignatureItem;
	onChange: (item: graphql.EvaluationSignatureItem, fillInBy: graphql.EvaluationFillInBy) => void;
}) {
	const formik = useFormik({
		initialValues: {
			fillInBy: props.fillInBy,
			title: props.item.title,
		},
		onSubmit: () => {},
	});

	useEffect(() => {
		if (!formik.values.title?.find(({ text }) => text.length > 0)) {
			return;
		}

		props.onChange(
			{
				...props.item,
				title: formik.values.title,
			},
			formik.values.fillInBy,
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formik.values.title, formik.values.fillInBy]);

	return (
		<FormikProvider value={formik}>
			<Flex p={3} flexDirection="column">
				<Title />
				<FilledInBy />
			</Flex>
		</FormikProvider>
	);
}
